import { render, staticRenderFns } from "./JudgesReport.vue?vue&type=template&id=24fcdaa2"
import script from "./JudgesReport.vue?vue&type=script&lang=js"
export * from "./JudgesReport.vue?vue&type=script&lang=js"
import style0 from "./JudgesReport.vue?vue&type=style&index=0&id=24fcdaa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports